import { Component, OnInit, Input, ViewChild } from '@angular/core';



@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html'
})

export class CategoriesComponent implements OnInit {
  @Input() categorias: any[];
  
  
  constructor( ) {
    
   }

  ngOnInit(): void {

    // console.log(this.nuevasCategorias);
    // console.log('categoria desde el init de categoria',this.nuevasCategorias[0].category_id);
    // this.categories.getCategorySelected(this.nuevasCategorias[0].category_id);
  }
 


}
